// src/pages/CategoryPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import productsData from '../data/products.json';
import ProductCard from '../components/ProductCard';
import ShopByCategory from '../components/ShopByCategory';

const CategoryPage = () => {
  const { categorySlug } = useParams();
  const [Products, setProducts] = useState([]);

  useEffect(() => {
    const filtered = productsData.products.filter(
      (product) => product.categories?.includes(categorySlug)
    );
    setProducts(filtered);
  }, [categorySlug]); // ✅ Ensures effect runs if route changes

  return (
    <div className="p-8">
      <h1 className="text-2xl font-bold capitalize mb-6">
        {categorySlug.replace(/-/g, ' ')} Products
      </h1>

      {Products.length > 0 ? (
        <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-4 gap-8">
          {Products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      ) : (
        <p className="text-gray-600">No products found for this category.</p>
      )}

      <ShopByCategory/>
    </div>
  );
};

export default CategoryPage;
